import React from 'react';

import { ConfigResponse } from '../../store/modules/merchant/types';
import PageWrapper from '../../common/PageWrapper';
import { useConfigUpsert } from '../../hooks';
import { useMerchant } from '../../contexts/MerchantContext';
import { CartEditsContent } from './components/CartEditsContent';
import { useGetConfigsQuery } from '../../store/modules/merchant/api';
import { toast } from '../../util/toast';
export const CartEdits = () => {
  const { merchantId, isLoading: merchantInfoLoading, canUpdateMerchantSettings } = useMerchant();

  const hasModifyAccess = canUpdateMerchantSettings();

  const { onConfigUpsert, isLoading: isSaving } = useConfigUpsert(merchantId);
  const { data: configs, isLoading: isLoadingConfigs } = useGetConfigsQuery(merchantId, {
    skip: !merchantId,
  });
  const disallowCartEditsConfig = configs?.find((c) => c.name === 'DISALLOW_CART_EDITS') as
    ConfigResponse<boolean> | undefined;

  return (
    <PageWrapper
      showParentHierarchyBanner
      data-testid="CART_EDITS"
      title="Cart Edits"
      description="Use this page to allow customers to edit their carts at checkout, such as remove items."
      isLoading={isLoadingConfigs || merchantInfoLoading}
    >
      <CartEditsContent
        key={configs?.[0]?.merchantId ?? merchantId}
        readOnly={!hasModifyAccess}
        isSaving={isSaving}
        disallowCartEditsConfig={disallowCartEditsConfig}
        onSave={async (disallowCartEdits) => {
          try {
            await onConfigUpsert({
              enabled: true,
              name: 'DISALLOW_CART_EDITS',
              value: disallowCartEdits,
              configId: disallowCartEditsConfig?.configId,
              merchantId: disallowCartEditsConfig?.merchantId,
            });
            toast.success('Changes saved successfully');
          } catch {
            toast.error(
              'An error occurred while saving these changes. Please try again later or contact Skipify Support',
            );
          }
        }}
      />
    </PageWrapper>
  );
};
